import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { UpdateProfileType } from "../schema/UpdateProfileSchema";
import { UpdateProfileResponse } from "../response/UpdateProfileResponse";
import { ValidationUpdateResponse } from "../response/ValidationUpdateResponse";

export const useUpdateProfile = () => {
    return useMutation({
        mutationFn: async (formData: UpdateProfileType) => privateApi.put(`/v4/me`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateProfileResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid profile data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update profile', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationUpdateResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid profile data format");
            } else {
                console.error('Failed to update profile', error);
                throw error;
            }
        },
    });
};